import React, { Component, Fragment, useState } from "react";
import classnames from "classnames";
import "react-responsive-modal/styles.css";
import Form from "react-bootstrap/Form";
import { Media } from "react-bootstrap";
//import Row from "react-bootstrap/Row";
import { Modal } from "react-responsive-modal";
import {
  // PopupActionButton,
  PopupInsideButton,
} from "../../../../components/reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { InputBoxComponent } from "../../../../components/reusableComponents/inputReusableComponent/InputBoxComponent";
import { DropDownButton } from "../../../../components/reusableComponents/dropDownButtonReusable/DropDownButton";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import isEmpty from "../../../../store/validation/is-Empty";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { ReusableOnboardingButton } from "../../../../components/vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TextField } from "@material-ui/core";
import Alert from "react-s-alert";
import { DropDownButtonMobile } from "../../../reusableComponents/dropDownButtonReusable/DropDownButtonMobile";

export class OrderbufferTimeMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      min_wait_time: "",
      max_wait_time: "",
      select_wait_time: "",
      errors: {},
      hasSetWaitTimeProps: false,
      loader: false,
      customModel: false,
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      nextProps.onboarding._id &&
      !isEmpty(nextProps.onboarding.orderBufferTime)
    ) {
      if (
        !isEmpty(nextProps.onboarding.orderBufferTime) &&
        !nextState.hasSetWaitTimeProps
      ) {
        return {
          select_wait_time: !isEmpty(nextProps.onboarding.orderBufferTime)
            ? nextProps.onboarding.orderBufferTime
            : "00-00",
          hasSetWaitTimeProps: true,
        };
      }
    }
    return null;
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onChangeWalkinWaitlist = (e) => {
    let { value, min, max, maxLength } = e.target;
    value =
      Math.max(Number(min), Math.min(Number(max), Number(value))) ||
      value.slice(0, maxLength);
    this.setState({
      [e.target.name]: value,
      errors: {},
    });
  };

  /***************************
   * @DESC Big Button Handler
   ***************************/
  bigButtonHandler = (e, type) => {
    e.preventDefault();
    const formData = {
      vendor_id: this.props.onboarding.vendor_id,
      id: this.props.onboarding._id,
      orderBufferTime: type,
    };
    this.props.create_and_update_restaurant(
      formData,
      (data) => this.onSuccess(data),
      (err) => this.onErrorSuccess(err)
    );
    // this.setState({
    //   select_wait_time: type,
    //   open: false,
    // });
  };

  bigButtonProcessingHandler = (e, type) => {
    e.preventDefault();
    console.log(type);
    this.setState({
      // select_wait_time: type,
      open: false,
    });
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  onSubmitHandler = (e) => {
    e.preventDefault();
    // const min_wait_time = this.state.min_wait_time;
    // const max_wait_time = this.state.max_wait_time;
    const formData = {
      vendor_id: this.props.onboarding.vendor_id,
      id: this.props.onboarding._id,
      orderBufferTime: this.state.select_wait_time,
    };
    this.props.create_and_update_restaurant(
      formData,
      (data) => this.onSuccess(data),
      (err) => this.onErrorSuccess(err)
    );
  };
  onSuccess = (data) => {
    this.setState({
      select_wait_time: data.orderBufferTime,
      open: false,
      customModel: false,
    });
    Alert.success(`<h4>Buffer time update successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  onErrorSuccess = (err) => {
    Alert.error(`<h4>${err?.responce?.data?.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  openCustomModel = (e) => {
    this.onCloseModal();
    this.setState({ customModel: !this.state.customModel });
  };

  render() {
    const { open, errors, select_wait_time, customModel } = this.state;
    return (
      <div>
        
        <DropDownButtonMobile
          dropDownCss="main-dropdown-section d-flex align-items-center justify-content-between cursor p-3 rounded border "

          headingText="Set Buffer time" 
          divClass="insidedropdown-div-othe d-flex"
          insideText={this.state.select_wait_time}
          displayDropDown={true}
          onClick={this.onOpenModal}
          extraStyles={{background:"black", color:"white"}}
        />

        {/* Custom Modal */}
        <CustomModal
          bigButtonHandler={this.bigButtonHandler}
          openCustomModel={this.openCustomModel}
          customModel={customModel}
          bigButtonProcessingHandler={this.bigButtonProcessingHandler}
          actionBy="Buffer"
        />


        {/* Original model */}
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            // overlay: "customOverlay-request-accept-cancelled",
            modal: "small-popup",
            closeButton: "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
          style={{ background: "black" }}
        >
          <div className="reusable-popup-header-newstyle">
            <h4 className="c-black font_24_b">Buffer Time</h4>
          </div>
          <div className="">
            <Form>
              <div className="mt-2 mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="col-6">
                    {/* <InputBoxComponent
                      displayLabel={false}
                      controlId="min_wait_time"
                      labelText="Enter Wait Time"
                      inputType="number"
                      min="00"
                      max="60"
                      maxLength="2"
                      placeHolder="Min Wait"
                      name="min_wait_time"
                      onChange={this.onChangeWalkinWaitlist}
                      value={this.state.min_wait_time}
                      required="required"
                      showBottom={true}
                      error={errors.min_wait_time}
                      inputClassName={classnames(
                        "input-component-inputfield text-center",
                        {
                          invalid: errors.min_wait_time,
                        }
                      )}
                    />
                  </div>
                  <div className="col-6">
                    <InputBoxComponent
                      displayLabel={false}
                      controlId="max_wait_time"
                      labelText="Enter Wait Time"
                      inputType="number"
                      placeHolder="Max Wait"
                      min="00"
                      max="60"
                      maxLength="2"
                      name="max_wait_time"
                      onChange={this.onChangeWalkinWaitlist}
                      value={this.state.max_wait_time}
                      required="required"
                      showBottom={true}
                      error={errors.max_wait_time}
                      inputClassName={classnames(
                        "input-component-inputfield text-center",
                        {
                          invalid: errors.max_wait_time,
                        }
                      )}
                    /> */}
                  </div>
                  {/* <div className="col-3 p-0">
                    <PopupActionButton
                      buttonText="Confirm"
                      buttonType="button"
                      buttonClass="smallcancel"
                      onClick={this.onSubmitHandler}
                    />
                  </div> */}
                  {/* <p className="minu-section">Mins</p> */}
                </div>
                {/* <div className="d-flex justify-content-between align-items-center">
                  <div className="col-6 text-left">
                    <Form.Text className={"text-muted input-component-bottom"}>
                      Minimum wait in mins
                    </Form.Text>
                  </div>
                  <div className="col-6 text-left">
                    <Form.Text className={"text-muted input-component-bottom"}>
                      Maximum wait in mins
                    </Form.Text>
                  </div> */}
                {/* <div className="col-2 text-center"></div> */}
                {/* </div> */}
                <hr />
                <div>
                  <h4
                    className="font_18_m c_black mb-4"
                    style={{ textAlign: "start" }}
                  >
                    Select one relevant option from below
                  </h4>
                  {/* <h4 className="font_14_r c_black mb-4">
                    Highest value from below will be sent as wait time
                  </h4> */}
                </div>
                <div className="row">
                  <div className="col-6 mobile-p-0 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "00-00"
                          ? "status-selected-button-box font_18_m mobile-f16-400 sts_sld_btn_box_a"
                          : "status-selected-button-box font_18_m mobile-f16-400"
                      }
                      buttonText="00 - 00 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "00-00")}
                    />
                  </div>
                  <div className="col-6 mobile-p-0 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "00-05"
                          ? "status-selected-button-box font_18_m mobile-f16-400 sts_sld_btn_box_a"
                          : "status-selected-button-box font_18_m mobile-f16-400"
                      }
                      buttonText="00 - 05 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "00-05")}
                    />
                  </div>
                  <div className="col-6 mobile-p-0 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "05-10"
                          ? "status-selected-button-box font_18_m mobile-f16-400 sts_sld_btn_box_a"
                          : "status-selected-button-box font_18_m mobile-f16-400"
                      }
                      buttonText="05 - 10 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "05-10")}
                    />
                  </div>
                  <div className="col-6 mobile-p-0 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "10-15"
                          ? "status-selected-button-box font_18_m mobile-f16-400 sts_sld_btn_box_a"
                          : "status-selected-button-box font_18_m mobile-f16-400"
                      }
                      buttonText="10 - 15 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "10-15")}
                    />
                  </div>
                  <div className="col-6 mobile-p-0 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "15-20"
                          ? "status-selected-button-box font_18_m mobile-f16-400 sts_sld_btn_box_a"
                          : "status-selected-button-box font_18_m mobile-f16-400"
                      }
                      buttonText="15 - 20 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "15-20")}
                    />
                  </div>
                  <div className="col-6 mobile-p-0 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "20-25"
                          ? "status-selected-button-box font_18_m mobile-f16-400 sts_sld_btn_box_a"
                          : "status-selected-button-box font_18_m mobile-f16-400"
                      }
                      buttonText="20 - 25 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "20-25")}
                    />
                  </div>
                  <div className="col-6 mobile-p-0 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "25-30"
                          ? "status-selected-button-box font_18_m mobile-f16-400 sts_sld_btn_box_a"
                          : "status-selected-button-box font_18_m mobile-f16-400"
                      }
                      buttonText="25 - 30 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "25-30")}
                    />
                  </div>
                  <div className="col-6 mobile-p-0 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time !== "00-00" &&
                        select_wait_time !== "00-05" &&
                        select_wait_time !== "05-10" &&
                        select_wait_time !== "10-15" &&
                        select_wait_time !== "15-20" &&
                        select_wait_time !== "20-25" &&
                        select_wait_time !== "25-30"
                          ? "status-selected-button-box font_18_m mobile-f16-400 sts_sld_btn_box_a"
                          : "status-selected-button-box font_18_m mobile-f16-400"
                      }
                      buttonText="Custom"
                      buttonType="button"
                      onClick={(e) => this.openCustomModel(e)}
                    />
                  </div>
                   {/* <div className="col-6 mobile-p-0 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "40-45"
                          ? "status-selected-button-box font_18_m mobile-f12-400 sts_sld_btn_box_a"
                          : "status-selected-button-box font_18_m mobile-f12-400"
                      }
                      buttonText="40 - 45 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "40-45")}
                    />
                  </div> */}
                  <div className="col-6 mobile-p-0 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "45-50"
                          ? "status-selected-button-box font_18_m mobile-f12-400 sts_sld_btn_box_a"
                          : "status-selected-button-box font_18_m mobile-f12-400"
                      }
                      buttonText="45 - 50 &nbsp; Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "45-50")}
                    />
                  </div>
                  <div className="col-6 mobile-p-0 mb-4">
                    <PopupInsideButton
                      buttonClass={
                        select_wait_time === "50-60"
                          ? "status-selected-button-box font_18_m mobile-f12-400 sts_sld_btn_box_a"
                          : "status-selected-button-box font_18_m mobile-f12-400"
                      }
                      buttonText="50 - 60 Mins"
                      buttonType="button"
                      onClick={(e) => this.bigButtonHandler(e, "50-60")}
                    /> 
                   </div> 
                </div>
              </div>
              {/* <div className="ml-3 d-flex">
                <ReusableOnboardingButton
                  buttonTitle="Cancel Button"
                  buttonClass={
                    "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                  }
                  buttonText="Cancel"
                  onClick={this.onCloseModal}
                  buttonType="button"
                />
                <ReusableOnboardingButton
                  buttonTitle="Confirm Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  buttonText="Confirm"
                  onClick={this.onSubmitHandler}
                  buttonType="button"
                />
              </div> */}
            </Form>
          </div>
        </Modal>
      </div>
      
    );
  }
}

OrderbufferTimeMobile.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(OrderbufferTimeMobile));

export const CustomModal = (props) => {
  const [state, setState] = useState({ min: 0, max: 0 });
  const onChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const [error, setError] = useState({ min: "", max: "" });

  const submit = (e) => {
    e.preventDefault();
    if (parseInt(state.max) < parseInt(state.min)) {
      setError({ min: "Invalid time" });
    } else if (!state.min) {
      setError({ min: "Invalid time" });
    } else if (!state.max) {
      setError({ max: "Invalid time" });
    } else {
      props.actionBy === "Buffer"
        ? props.bigButtonHandler(e, `${state.min}-${state.max}`)
        : props.bigButtonProcessingHandler({ max: state.max, min: state.min });
      props.openCustomModel();
    }
  };
  return (
    <Fragment>
      <Modal
        open={props.customModel}
        onClose={props.openCustomModel}
        center
        classNames={{
          // overlay: "customOverlay-request-accept-cancelled",
          modal: "small-popup",
          closeButton: "customCloseButton",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
        style={{ background: "black" }}
      >
        <div className="reusable-popup-header-newstyle">
          <h4 className="c-black font_24_b">
            Custom {props.actionBy === "Buffer" ? "Buffer" : "Processing"} Time
          </h4>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <TextField
              variant="outlined"
              fullWidth
              value={state.min}
              helperText="Min Time"
              onChange={onChange}
              name="min"
              type="number"
              error={error.min}
            />
            {error.min && <span style={{ color: "red" }}>{error.min}</span>}
          </div>
          <div className="col-6">
            <TextField
              variant="outlined"
              fullWidth
              value={state.max}
              helperText="Max Time"
              onChange={onChange}
              name="max"
              type="number"
              error={error.max}
            />
            {error.max && <span style={{ color: "red" }}>{error.max}</span>}
          </div>
        </div>
        <br />
        <br />
        <div className="d-flex justify-content-between">
          <button
            className="btn btn-outline-secondary"
            onClick={props.openCustomModel}
          >
            Cancel
          </button>
          <button className="btn btn-danger" onClick={(e) => submit(e)}>
            Confirm
          </button>
        </div>
      </Modal>
    </Fragment>
  );
};
